

<div class="table-container">
    <table class="table is-fullwidth">
        <tbody>
            <tr>
                <th>Banco</th>
                <td>Banorte</td>
            </tr>
            <tr>
                <th>Nombre</th>
                <td>Logística a Bordo</td>
            </tr>
            <tr>
                <th>Cuenta</th>
                <td>1120452843</td>
            </tr>
            <tr>
                <th>CLABE</th>
                <td>072 691 01120452843 9</td>
            </tr>
        </tbody>
    </table>
</div>

<article class="message is-info">
    <div class="message-header">Envianos tu comprobante</div>
    <div class="message-body">
        Envianos un correo con la captura de tu pago al correo: 
        <b>
            <a href="mailto:pagos@logisticabordo.com,administracion@logisticabordo.com">pagos@logisticabordo.com</a>
        </b>
    </div>
</article>